export interface LocationModel {
    id: number,
    codeMetric: number | null,
    name: string
}

export const locationModelInitial: LocationModel = {
    id: 0,
    codeMetric: null,
    name: ''
};